import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper
    }
})

export default class GrossingTouchTagsSidepanel extends Vue {
}
